import { FC, useMemo } from 'react';
import { Box, Skeleton } from '@chakra-ui/react';

import Graph from 'features/Dashboard/pages/components/Graph';

import { LoadingGraphSkeletonBody } from '../../../components/LoadingGraphSkeletonBody';
import { LoadingIntervalSkeleton } from '../../../components/LoadingIntervalSkeleton';

const LoadingBarPair: FC = () => {
  return (
    <Box alignItems="flex-end" display="flex" gap="4px">
      <Skeleton
        borderRadius="radius-0"
        borderTopRadius="radius-4"
        endColor="grey.300"
        height={Math.floor(Math.random() * (325 - 200)) + 200}
        startColor="grey.100"
        width="20px"
      />
      <Skeleton
        borderRadius="radius-0"
        borderTopRadius="radius-4"
        endColor="grey.300"
        height={Math.floor(Math.random() * (325 - 200)) + 200}
        startColor="grey.100"
        width="20px"
      />
    </Box>
  );
};

// 12 bar pairs to make for 12 months
const BAR_PAIRS_QUANTITY = 12;

const LoadingBarChart: FC = () => {
  // set in a useMemo to prevent "moving" bars on re-renders
  const barPairs = useMemo(() => {
    const innerBarPairs = [];
    for (let i = 0; i < BAR_PAIRS_QUANTITY; i++) {
      innerBarPairs.push(<LoadingBarPair key={i} />);
    }

    return innerBarPairs;
  }, []);

  return (
    <Box
      alignItems="flex-end"
      display="flex"
      height="100%"
      justifyContent="space-between"
      left="0"
      overflowX="hidden"
      padding="0px 40px"
      position="absolute"
      top="0"
      width="100%"
    >
      {barPairs}
    </Box>
  );
};

const LoadingTreasuryGraph: FC = () => (
  <Box>
    <LoadingIntervalSkeleton />
    <Graph marginTop="space-24" position="relative">
      <LoadingBarChart />
      <LoadingGraphSkeletonBody height="325px" />
    </Graph>
  </Box>
);

export default LoadingTreasuryGraph;
